<!-- Dialog: FILTER NEW-->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [modal]="false"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.dialogData.title_text }} </p-header>

  <div fxLayoutWrap fxLayout="column" fxLayoutGap="15px" class="dialog__body__filter-new">
    <div fxLayout="row" fxFlexFill>
      <div fxFlex class="p-autocomplete-float-group">
        <label for="public-profile-name">Public Profile Name</label>
        <bfx-text-input
          id="public-profile-name"
          #_saveProfile_publicProfileName_autoComplete
          [(ngModel)]="data.dialogData.autocomplete_publicProfileName"
          size="sm"
          field="label"
          (ngModelChange)="helpersaveProfile_validateProfileName($event)"
          autoHighlight="true"
          dataKey="value"
          delay="4"
          [maxLength]="50"
          [style]="{'width':'100%'}"
          [ngClass]="{'p-autocomplete p-autocomplete-float-input filter__dialog__filter-copy__autocomplete--filterName': true,
                        'p-autocomplete-float-input-valid': !!data.dialogData.autocomplete_publicProfileName}"
        >
        </bfx-text-input>
        <div
          class="p-autocomplete-float-label-error"
          [ngStyle]="{ visibility: profileNameValid || profileNameEmpty ? 'hidden' : 'visible'}"
        >
          {{data.dialogData.message_text_invalid}}
        </div>
      </div>
    </div>
  </div>

  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="actionSaveProfile_close()"
      label="Cancel"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionSaveProfile_confirm()"
      label="Save"
      [disabled]="!data.dialogData.autocomplete_publicProfileName || !profileNameValid"
    ></button>
  </p-footer>
</p-dialog>
